"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
const image_warning_1 = require("./image-warning");
exports.WarningGroup = ({ translate, loadingImage = false, groupName, warnings = [], }) => {
    if (loadingImage) {
        return (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
            hyperapp_1.h("e-icon", { icon: "e-info-circle", type: "inline", size: "small" }),
            translate('loadingImageText'),
            hyperapp_1.h("e-spinner", { "data-size": "table" })));
    }
    return (hyperapp_1.h(uikit_e_field_1.UiKitEField, null, warnings
        .filter(({ group }) => group === groupName)
        .map(({ type, message }) => hyperapp_1.h(image_warning_1.ImageWarning, { type: type, message: message }))));
};
//# sourceMappingURL=warning-group.js.map